import { createContext, useContext } from 'react';

export const ModalContext = createContext({ modal: null, openModal: () => {}, closeModal: () => {} });

export const useModal = () => useContext(ModalContext);
